<template>
    <div class="container remove-padding-margin">
        <div class="container remove-padding-margin" id="activationkomisi">
            <div class="fixed-judul fixed-top">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                        <img src="../../assets/gambar/back-blue.svg" alt="">
                    </div>
                    <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                        <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Pengaturan Komisi</h6>
                    </div>
                    <div class="col-md-2 col-sm-2 col-2">
                    </div>
                </div>
            </div>
            <main class="=">
                <div class="add-padding-default flex-100" id="page1">
                    <div class="flex-1 pad-top-66">
                        <div class="mar-top-40">
                            <div class="image text-alignC">
                                <img class="" src="../../assets/icons/Vector.svg" alt="">
                            </div>
                            <div class="font-16 font-weight-bold text-center">
                                Karyawan Tidak Menerima Komisi
                            </div>
                            <div class="font-14 text-center color-8080 mar-bottom-30">
                                Klik tombol dibawah untuk menambahkan
                            </div>
                            <div class="text-alignC" v-if="choice.length===0">
                                <div class="pointer-with-nav">
                                    <span><img class="plus-icon-blue" src="../../assets/img/plus-1.svg" alt=""></span>
                                </div>
                                <div class="color-206CF" @click="gocreate() && validateAccess('employeesSalesCommision.create')">Buat Komisi Baru</div>
                            </div>
                            <div class="text-alignC" v-else>
                                <div class="pointer-with-nav">
                                    <span><img class="plus-icon-blue" src="../../assets/img/plus-1.svg" alt=""></span>
                                </div>
                                <div class="color-206CF" @click="golistkomisi">Pilih Jenis Komisi</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-100" id="page2">
                    <div class="flex-1 pad-top-66">
                        <div class="add-padding-default mar-bottom-16">
                            <div class="font-14 color-6f7 letter-space-002 line-height-20 mar-bot-8">Komisi yang
                                diterima {{this.aktif.karyawan}}
                            </div>
                            <div class="font-16 line-height-25 letter-space-002 font-weight-600 mar-bot-8">
                                {{this.nama}}
                            </div>
                            <div class="mar-bot-8 font-14 line-height-20 letter-space-002 color-6f7 rupiah"
                                 v-for="detail in this.detailjenisgaji">Penjualan > {{detail.total_omset}} &#183 Komisi
                                {{detail.persentase_komisi}}%
                            </div>
                        </div>
                        <div class="border-top-EDED">
                            <div class="add-padding-default row mar-top-16 remove-margin">
                                <div class="mar-right-10" @click="golistkomisi">
                                    <button type="button"
                                            class="btn btn-outline-primary btn-long font-16 letter-space-002 line-height-25 font-weight-600 pad-8-12"
                                            style="width: 120px">Ubah Komisi
                                    </button>
                                </div>
                                <div class="" @click="validateAccess('employeesSalesCommision.update') && deletekomisi()">
                                    <button type="button"
                                            class="btn btn-outline-hapus btn-long font-16 letter-space-002 line-height-25 font-weight-600 pad-8-12"
                                            style="width: 120px">Hapus Komisi
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
					<!--<div class="button-lanjut add-padding-default">-->
					<!--    <button class="btn btn-login btn-long remove-margin" id="btnsetgaji">-->
					<!--    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"-->
					<!--          v-if="isClicked === true"></span><span id="textbtnsetgaji">Simpan</span>-->
					<!--    </button>-->
					<!--</div>-->
                </div>
                <div class="modal fade" id="modalmaintance" role="dialog">
                    <div class="modal-dialog modal-lg  bani-modal">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="nav-btn kiri"></div>
                                <h5 class="navbar-title text-center">Under Maintance</h5>
                                <div class="nav-btn kanan tutup">
                                    <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                </div>
                            </div>
                            <div class="modal-body">
                                <div class="font-weight-bold color-206CF">Under Maintance</div>
                            </div>
                            <div class="modal-footer remove-mar-lr">
                                <div style="margin-right: 0px">
                                    <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal">
                                        UNDER MAINTANCE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
        <ListCommision v-bind:class="{hidesection: !islistkomisi}" v-on:isaktif="isaktif"
                       v-bind:setidkaryawankomisi="setidkaryawan" v-on:gocreate="gocreate" ref="getchoice" v-on:getdetailkomisi="getaktifkomisi"/>
        <CreateCommision v-bind:class="{hidesection: !iscreatekomisi}" v-on:iscreate="iscreate" v-on:islistkomisi="golistkomisi" />
    </div>
</template>

<script>
    import CreateCommision from "./CreateCommision";
    import ListCommision from "./ListCommision";

    export default {
        name: "ActivationCommision",
        props: ['setidkaryawan'],
        components: {
            CreateCommision, ListCommision
        },
        data() {
            return {
                idkaryawan: this.setidkaryawan,
                iscreatekomisi: false,
                islistkomisi: false,
                isClickedloader: false,
                isClicked: false,
                choice: [],
                aktif: {},
                nama: '',
                length: 0,
                detailjenisgaji: [],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            this.idkaryawan = this.$route.params.idkaryawan
            $('#page1').show()
            $('#page2').hide()
            // this.smartTrackingView("pengaturan_komisi_karyawan",{"idkaryawan":this.idkaryawan});

        },
        methods: {
            back() {
                this.$emit("isdetail")
            },
            gocreate() {
                this.islistkomisi = false;
                this.iscreatekomisi = true;
                $('#activationkomisi').hide();
            },
            golistkomisi() {
                if (!this.validateAccess('employeesSalesCommision.update')) return;
                this.islistkomisi = true;
                this.iscreatekomisi = false;
                $('#activationkomisi').hide();
                this.$refs.getchoice.listkomisi()
	            this.backButtonPressed(this.$refs.getchoice.back)
            },

            setidkaryawankomisi() {
                this.idkaryawan = this.setidkaryawan
            },

            async deletekomisi() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const deletekomisi = new FormData();
                    deletekomisi.append('hapus', 1)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/hapus_komisi_sales_karyawan?idkaryawan=' + this.setidkaryawan, deletekomisi, this.requestHeaders);
                    if (response.data.status === true) {
                        this.getaktifkomisi()
                        $('#loadingPage').hide()
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.success(response.data.msg)
                    } else {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
	                    this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked = false
	                $('#textBtn2').show()
	                $('#btnNext').prop('disabled', false);
                }
            },

            isaktif() {
                $('#activationkomisi').show()
                this.islistkomisi = false
                this.getchoicekomisi()
	            this.backButtonPressed(this.back)
            },

            iscreate() {
                $('#activationkomisi').show()
                this.iscreatekomisi = false
                this.getchoicekomisi()
            },

            async getaktifkomisi() {
                this.aktif = ''
                this.nama = ''
                this.detailjenisgaji = []
                // $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_karyawan_komisi_sales?idkaryawan=' + this.setidkaryawan, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').hide()
                        $('#loadingPage').removeClass('overlayLoading');
                        if (response.data.lenght == 0) {
                            $('#page1').show()
                            $('#page2').hide()
                            this.lenght = response.data.lenght;
                        } else {
                            $('#page1').hide()
                            $('#page2').show()
                            this.lenght = response.data.lenght;
                            this.aktif = response.data;
                            this.nama = this.aktif.data.nama;
                            this.detailjenisgaji = this.aktif.data.detail_jenisgaji_sales;
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked = false
	                $('#textBtn2').show()
	                $('#btnNext').prop('disabled', false);
                }
            },

            async getchoicekomisi() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_jenis_komisi_sales', this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                        this.choice = [];
                        var data = response.data.data;
                        for (var i = 0; i < data.length; i++) {
                            this.choice.push({
                                nama: data[i].nama,
                            })
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked = false
	                $('#textBtn2').show()
	                $('#btnNext').prop('disabled', false);
                }
            },
        }
    }
</script>

<style scoped>
    /*.hidesection{*/
    /*    display: none;*/
    /*}*/
    .image.text-alignC {
        margin-bottom: 20px;
    }

    .pointer-with-nav {
        display: flex;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #206CFF;
        cursor: pointer;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        align-content: center;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 292px;
        left: 90px;
    }

    .plus-icon {
        width: 32px;
    }

    .plus-icon-blue {
        width: 20px;
    }

    .pad-8-12 {
        padding: 6px 10px;
    }
</style>